import DynamicTable from './table/main.vue';
import DynamicForm from './form/index.vue';

export default {
    DynamicTable,
    DynamicForm
}